import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Preloader from "../../components/Preloader";
import Input from "../../components/Input";
import Select from "../../components/Select";
import { SaleService } from "../../services/SaleService";
import { TypesService } from "../../services/TypesService";
import { ReportadasService } from "../../services/ReportadasService";

const RegistrarReportada = ({
  token,
  user
}) => {
  const navigate = useNavigate();
  const { id, j } = useParams();
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const [gContrat, setGContrat] = useState("");
  const [contratAssinged, setContratAssinged] = useState("");
  const [reportedSelected, setReportedSelected] = useState("");
  const [tematicSelected, setTematicSelected] = useState("");
  const [callSelected, setCallSelected] = useState("");
  const [installSelected, setInstallSelected] = useState("");
  const [notes, setNotes] = useState("");
  const [statusSelected, setStatusSelected] = useState("");
  const [tematicList, setTematicList] = useState([]);
  const [data, setData] = useState({});
  const [reportadas, setReportadas] = useState([]);
  const [statusClientList, setStatusClientList] = useState([]);
  const onlyRead = typeof j != "undefined" && j && j === "only";

  const handleBackToList = () => {
    navigate("/admin/reportadas"); // ajusta según tu ruta de listado
  };

  const fetchVenta = async () => {
    setLoading(true);
    try {
      const responseTematic = await TypesService.get({
        token: token,
        table: 'tematico'
      });
      let rStatusList = [];
      const responseStatus = await TypesService.get({
        token: token,
        table: 'estado_cliente'
      });
      responseStatus.map((r) => {
        if (r.id !== 4) {
          rStatusList.push({
            id: r.id,
            nombre: r.descripcion
          });
        }
      });
      setStatusClientList(rStatusList);
      setTematicList(responseTematic);
      const responseReportadas = await ReportadasService.get({
        token: token,
        vid: id
      });
      setReportadas(responseReportadas);
      const responseAvance = await SaleService.fetchAvanceVentaPorId(token, id);
      setData(responseAvance.data.venta);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error al obtener la venta:", error);
    }
  };

  useEffect(() => {
    if (id) {
      fetchVenta();
    }
  }, [id, token]);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await ReportadasService.save({
      token: token,
      formData: {
        vid: id,
        gContrat: gContrat,
        contratAssinged: contratAssinged,
        reportedSelected: reportedSelected,
        tematicSelected: tematicSelected,
        callSelected: callSelected,
        installSelected: installSelected,
        notes: notes,
        statusSelected: statusSelected,
      }
    });

    setGContrat("");
    setContratAssinged("");
    setReportedSelected("");
    setTematicSelected("");
    setCallSelected("");
    setInstallSelected("");
    setNotes("");
    setStatusSelected("");

    setLoading(false);
    fetchVenta();
  };

  return (
    <div className="ventas-admin-content">
      {loading && <Preloader />}
      <div className="breadcrumb-container">
        <span className="breadcrumb-link" onClick={handleBackToList}>
          ← Listado de Reportados
        </span>
        <span className="breadcrumb-current"> / Reportados</span>
      </div>
      <div className="flex justify-between">
        <div className="container w-70">
          <div className="dashboard-card nueva-venta-responsive">

            <form
              className="nueva-venta-form"
              onSubmit={handleSubmit}
              autoComplete="off"
            >

              {error && <div className="error-message">{error}</div>}
              {success && <div className="success-message">{success}</div>}

                <div className="flex justify-between">
                  <Input title="Gestor Contrata" value={gContrat} setValue={setGContrat} placeholder="Ingrese" className="w-30" disable={onlyRead} />
                  <Input title="Contrata asignada" value={contratAssinged} setValue={setContratAssinged} placeholder="Ingrese" className="w-30" disable={onlyRead} />
                  <Select title="Reportado" value={reportedSelected} setValue={setReportedSelected} options={[
                    {
                      id: 0,
                      nombre: 'Seleccione'
                    },
                    {
                      id: 1,
                      nombre: 'Bien reportado'
                    },
                    {
                      id: 2,
                      nombre: 'Mal reportado'
                    },
                  ]} className="w-30" disable={onlyRead} />
                </div>

                <div className="flex justify-between pt-10">
                  <Select title="Temático" value={tematicSelected} setValue={setTematicSelected} options={[
                    ...[
                      {
                        id: 0,
                        nombre: 'Seleccione'
                      }
                    ],
                    ...tematicList
                  ]} className="w-30" disable={onlyRead} />
                  <Select title="Llamada" value={callSelected} setValue={setCallSelected} options={[
                    {
                      id: 0,
                      nombre: 'Seleccione'
                    },
                    {
                      id: 1,
                      nombre: 'NO CONTACTO'
                    },
                    {
                      id: 2,
                      nombre: 'CONTACTO EFECTIVO'
                    },
                  ]} className="w-30" disable={onlyRead}/>
                  <Select title="Instalado" value={installSelected} setValue={setInstallSelected} options={[
                    {
                      id: 0,
                      nombre: 'Seleccione'
                    },
                    {
                      id: 1,
                      nombre: 'Si'
                    },
                    {
                      id: 2,
                      nombre: 'No'
                    },
                  ]} className="w-30" disable={onlyRead} />
                </div>

                <div className="flex justify-between pt-10 items-end">
                  <Input title="Observación" value={notes} setValue={setNotes} placeholder="" className="w-30" type="textarea" disable={onlyRead}/>
                  <Select title="Estado" value={statusSelected} setValue={setStatusSelected} options={
                    [
                      ...[
                        {
                          id: 0,
                          nombre: 'Seleccione'
                        }
                      ],
                      ...statusClientList
                    ]} className="w-30" disable={onlyRead} />
                  <div className="w-30">
                    <button
                      className="btn btn-primary w-full"
                      type="submit"
                      disabled={loading || onlyRead}
                    >
                      {loading
                        ? "Procesando..."
                          : "Registrar"
                      }
                    </button>
                  </div>
                </div>
            </form>
          </div>

          <div className="ventas-table-wrapper pt-40">
            <table className="ventas-table">
              <thead>
                <tr>
                  <th>F. Gestión</th>
                  <th>Back</th>
                  <th>Estado</th>
                  <th>Temático</th>
                  <th>Llamada</th>
                  <th>Instalado</th>
                  <th>Observación</th>
                  <th>Back</th>
                  <th># Contac</th>
                </tr>
              </thead>
              <tbody>
                {
                  reportadas.map((r, k) => (
                    <tr key={r.id}>
                      <td>{new Date(r.fecha).toLocaleDateString()}</td>
                      <td>Back</td>
                      <td>{r.estado_cliente}</td>
                      <td>{tematicList.length > 0 && r.tematico_id ? tematicList.filter((t) => t.id = r.tematico_id).pop().nombre : ''}</td>
                      <td>{r.llamada === 1 ? 'No contacto' : 'Contacto Efectivo'}</td>
                      <td>{r.instalado === 1 ? 'Si' : 'No'}</td>
                      <td>{r.observaciones}</td>
                      <td>{r.nombre_responsable}</td>
                      <td>{k+1}</td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
          </div>

        </div>
        <div className="container w-30 bl-1">
          {
            typeof data.id != "undefined" && (
              <div className="container-gray">
                <p>Asesor - {`${data.nombre_vendedor} ${data.apellido_vendedor}`}</p>
                <p>SUPERVISOR - {typeof data.supervisor.id != "undefined" ? `${data.supervisor.nombre}` : ''}</p>
                <p>CÓDIGO CLIENTE - {data.cod_cliente}</p>
                <p>ESTADO - REPORTADO</p>
                <p>NÚMERO DOCUMENTO - {data.numero_documento}</p>
                <p>NOMBRES COMPLETOS / RAZÓN SOCIAL</p>
                <p>{`${data.nombre_cliente || ''} ${data.razon_social}`}</p>
                <p>TELÉFONO: {data.telefono_1}</p>
                <p>TELÉFONO: {data.telefono_2}</p>
                <p>tipificación | {data.tipificacion_reportada}</p>
                <p>subtipificación</p>
                <p>{data.subtipificacion_reportada}</p>
                <p>Observación</p>
                <p>{data.observacion}</p>
                {
                  !onlyRead && data.id_estado_cliente != 4 && (
                    <button
                      className="btn btn-orange"
                      type="button"
                      disabled={loading}
                      onClick={async () => {
                        if (!window.confirm("¿Está seguro de anular este avance?")) return;
                        setLoading(true);
                        await ReportadasService.disable({
                          token: token,
                          formData: {
                            avid: id,
                            vid: data.id_venta && data.id_venta !== "" ? data.id_venta : 0,
                            disable: true,
                            status: 4,
                          }
                        });
                        setLoading(false);
                        fetchVenta();
                        navigate(`/admin/reportadas`);
                      }}
                    >
                      Anular
                    </button>
                  )
                }
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default RegistrarReportada;
